import { track, useTracking } from '../../../../lib/analytics'

import HomePageSiteNavSection from './HomePageSiteNavSection'
import LoggedInSiteNavSection from './LoggedInSiteNavSection'
import MinimalSiteNavSection from './MinimalSiteNavSection'

interface SiteNavSectionProps {
  activeNavItem?: string
  showMinimalView: boolean
  showAcquisitionView: boolean
  isLoggedIn: boolean
}

const SiteNavSection = ({
  activeNavItem,
  showMinimalView,
  showAcquisitionView,
  isLoggedIn,
}: SiteNavSectionProps) => {
  const tracker = useTracking()

  const trackClick = (eventCta: string) => {
    tracker.trackEvent({
      event: track.navbarClicked,
      eventCta,
      eventLocation: track.EventLocation.WEB_TOP_NAV,
    })
  }

  if (showAcquisitionView) {
    return <></>
  }

  if (showMinimalView) {
    return <MinimalSiteNavSection trackClick={trackClick} />
  }

  if (isLoggedIn) {
    return (
      <LoggedInSiteNavSection
        activeNavItem={activeNavItem}
        trackClick={trackClick}
      />
    )
  }

  return (
    <HomePageSiteNavSection
      activeNavItem={activeNavItem}
      trackClick={trackClick}
    />
  )
}

export default SiteNavSection
